/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FeaturePermissionDto } from '../models/feature-permission-dto';


/**
 * API for browse access control permissions.
 */
@Injectable({
  providedIn: 'root',
})
export class AccessControlPermissionsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation listPermissionsByAccessControl
   */
  static readonly ListPermissionsByAccessControlPath = '/access-control-permission/{accessControl}';

  /**
   * List feature permissions by access control.
   *
   * Returns a list of permissions filtered by access control level.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listPermissionsByAccessControl()` instead.
   *
   * This method doesn't expect any request body.
   */
  listPermissionsByAccessControl$Response(params: {
    accessControl: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<FeaturePermissionDto>>> {

    const rb = new RequestBuilder(this.rootUrl, AccessControlPermissionsService.ListPermissionsByAccessControlPath, 'get');
    if (params) {
      rb.path('accessControl', params.accessControl, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FeaturePermissionDto>>;
      })
    );
  }

  /**
   * List feature permissions by access control.
   *
   * Returns a list of permissions filtered by access control level.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listPermissionsByAccessControl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listPermissionsByAccessControl(params: {
    accessControl: string;
  },
  context?: HttpContext

): Observable<Array<FeaturePermissionDto>> {

    return this.listPermissionsByAccessControl$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<FeaturePermissionDto>>) => r.body as Array<FeaturePermissionDto>)
    );
  }

}
